import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import Navbar from "@/components/layout/Navbar"
import MainLayout from "@/components/layout/MainLayout"
import { supabase } from "@/lib/supabase"

export default function TrattamentoDettaglioPage() {

  const { id } = useParams()
  const [trattamento, setTrattamento] = useState<any>(null)

  useEffect(() => {
    const fetchData = async () => {

      const { data, error } = await supabase
        .from("trattamenti")
        .select("*")
        .eq("id", id)
        .single()

      if (!error) setTrattamento(data)
    }

    fetchData()
  }, [id])

  if (!trattamento) return <p className="p-20 text-center">Caricamento...</p>

  const whatsapp = `https://wa.me/390683796865?text=Ciao%20Alkimya%2C%20vorrei%20info%20sul%20trattamento%20${encodeURIComponent(trattamento.nome)}`

  return (
    <MainLayout>

      <Navbar />

      {/* HERO */}
      <section className="relative h-[70vh] flex items-center justify-center">

        <img
          src={trattamento.immagine}
          className="absolute inset-0 w-full h-full object-cover"
        />

       <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/40 to-black/70"></div>

        <div className="relative text-center text-white px-6">

          <h1 className="text-5xl md:text-6xl font-serif mb-4 animate-fadeUp">
            {trattamento.nome}
          </h1>

          <p className="text-white/80 text-lg animate-fadeUp delay-200">
            {trattamento.durata}
          </p>

        </div>

      </section>

      {/* CONTENUTO */}
      <section className="py-20 px-6 text-center">

        <div className="max-w-3xl mx-auto">

        <div className="max-w-3xl mx-auto space-y-6 text-gray-600 text-lg leading-relaxed mb-10">

  {(trattamento.descrizione || trattamento.descrizione_breve)
    ?.split("\n")
    .map((par, i) => (
      <p key={i}>{par}</p>
    ))}

</div>

          <p className="text-2xl font-semibold mb-10">
            {trattamento.prezzo}
          </p>

          <a
            href={whatsapp}
            target="_blank"
            className="inline-flex items-center gap-3
                       px-10 py-4
                       bg-black text-white
                       rounded-full
                       hover:scale-105 transition"
          >
            Prenota su WhatsApp
          </a>

        </div>

      </section>
{/* CTA STICKY MOBILE */}
<a
  href={whatsapp}
  target="_blank"
  className="fixed bottom-6 left-1/2 -translate-x-1/2
             px-8 py-4
             bg-black text-white
             rounded-full
             shadow-2xl
             md:hidden
             z-50"
>
  Prenota ora
</a>
    </MainLayout>
  )
}